
//local url 
// const url = "http://localhost:8001"
// const url = "http://192.168.0.37:3016"
// const url = "https://api.plywoodbazar.com/test"
const url = "https://api.plywoodbazar.com"

const S3_BASE = "https://plywood-backend-images.s3.ap-south-1.amazonaws.com"

export const generateImageUrl = (fileName) => {
  if (!fileName) return ""
  if (String(fileName).startsWith("http")) return fileName
  const clean = String(fileName).startsWith("/") ? String(fileName).slice(1) : String(fileName)
  return `${S3_BASE}/${clean}`
}

export const generateExportUrl = (fileName) => `${url}/uploads/${fileName}`

export const generateFilePath = generateImageUrl

export const handleImageError = (e) => {
  e.target.onerror = null
  e.target.src = "/no-image.png"
}


export default url
